import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { BUTTON_VARIANTS } from "./constants";

export const buttonGroupDataSchema = z.object({
  buttons: z
    .array(
      z.object({
        value: z.string().describe("Sent back in the click event's detail."),
        label: z.string().optional(),
        icon: z.string().optional(),
        ariaLabel: z
          .string()
          .optional()
          .describe(
            "Accessible name and tooltip, for a button carrying only an icon.",
          ),
      }),
    )
    .default([])
    .describe(
      "Buttons parsed from the light DOM (<rwc-button-group-item> elements inside <rwc-button-group>), not a Twig-authored attribute.",
    ),
  variant: z.enum(BUTTON_VARIANTS).optional(),
  size: z.enum(SIZES).optional(),
  disableRipple: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  onButtonClick: z
    .custom<(value: string) => void>()
    .optional()
    .describe(
      "Internal callback bound by readButtonGroupSlotted, not a Twig-authored attribute.",
    ),
});

export type ButtonGroupDataProps = z.infer<typeof buttonGroupDataSchema>;
